@if (self$ | async; as self) {
	@if (params$ | async; as params) {
		@if (params.get("smode") !== "compare" && $any(self).isNewValidVersion && visible) {
			<article
				[class.mobile]="(layoutService.breakpoint | async)?.isSmall"
				class="card"
				animate.leave="stages-fade-out"
			>
				<div class="label">
					<span class="h3"
						translate="process.notification.new.valid.version.message"
						[translateParams]="{
							previous: $any(self).previousValidVersionDisplayName,
							current: $any(self).versionDisplayName,
						}"
					></span>
					<div class="buttons">
						<button
							(click)="open($any(self).previousValidVersionIdentifier, $any(self).previousValidVersionDiffValid)"
							translate="process.notification.new.valid.version.show"
						></button>
						<button (click)="markAsSeen(self.id)" translate="process.notification.new.valid.version.seen"></button>
					</div>
				</div>
			</article>
		}
	}
}
